import React from "react";

const MapFields = ({
  setColumnRows,
  error,
  fileContent,
  columnRows,
  setError,
  setMapFields,
  columnHeader,
  mapToTable,
  setStep,
  uploadLoading
}) => {
  return (
    <div className="map-fields">
      <div className="w60">
        <div>
          <span className="flex-start">
            <div style={{ color: "#525353" }}>Your Selected File :</div>
            <div
              style={{
                color: "#474186",
                marginLeft: "1rem",
              }}
            >
              {fileContent.name}
            </div>
          </span>
          <div style={{ color: "#525353", margin: "0.5rem 0" }}>
            The best match to each field on the selected file have been
            auto-selected.
          </div>
        </div>
        <div>
          <div className="fields">
            <div className="flex-between header">
              <div>Fields</div>
              <div>Imported File Headers</div>
            </div>
            {columnHeader.map((ele) => (
              <div className=" mbHalf flex-between">
                <label for="grid-state" style={{ color: "#2A254F" }}>
                  {ele.Header}
                </label>

                <select
                  id="grid-state"
                  style={{ color: "#2A254F" }}
                  defaultValue={fileContent.columns.find(
                    (itm) => itm === ele.Header
                  )}
                  onChange={(e) => {
                    setColumnRows({
                      ...columnRows,
                      [ele.Header]: e.target.value,
                    });
                  }}
                  placeholder={ele.Header?.replace("_", " ")}
                >
                  {fileContent.columns.map((col, i) => {
                    return (
                      <option value={col} defaultValue={fileContent.columns[0]}>
                        {col}
                      </option>
                    );
                  })}
                </select>
              </div>
            ))}

            {error && <div style={{ color: "#ff0000" }}>{error}</div>}
          </div>
        </div>
      </div>
      <div>
        <button
          type="button"
          style={{
            background:
              "transparent linear-gradient(0deg, #F2F4F7 0%, #FEFFFF 100%) 0% 0% no-repeat padding-box",
            color: "#354052",
            borderColor: "#CED0DA",
            height: "2.5rem",
            padding: "0 1rem",
            marginRight: "1rem",
          }}
          onClick={() => {
            setError("");
            setMapFields(false);
            setStep(0);
          }}
        >
          Previous
        </button>
        <button
          type="button"
          className="primary-btn"
          onClick={() => {
            mapToTable();
          }}
          disabled={uploadLoading}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default MapFields;
